// eslint-disable-next-line jira/filename-case
import React, { useEffect } from 'react';
import { RenderAfterGlobalHydrationCompletion } from '@jira/ssr__global-hydration-completeness/src/RenderAfterGlobalHydrationCompletion.tsx';
import { useIsHydrateRenderMode } from '@jira/ssr__hydrate-render-mode/src/useIsHydrateRenderMode.tsx';
import { BackgroundPriority } from '@jira/platform__services-non-critical/src/BackgroundPriority.tsx';
import usePageLoadedSubscriber from '@atlassian/jira-spa-state-controller/src/components/page-loaded-state/index.tsx';

type JIRA_READY_STATUS = {
	/**
	 * the absence of this field means nothing has started yet
	 */
	started: boolean;
	/**
	 * indicates whether the page has finished loading "main blocks". In does not mean it's loaded
	 * @deprecated use readyForInteractions instead
	 */
	loaded: boolean;
	/**
	 * indicates that UFO send FINISH_INTERACTION
	 * @deprecated use readyForInteractions instead
	 */
	onhold: boolean;
	/**
	 * indicates the page readyness to for user interactions
	 */
	readyForInteractions?: boolean;
};

const setReadyStatus = (status: Partial<JIRA_READY_STATUS>) => {
	if (typeof window !== 'undefined' && window.__JIRA_READY_STATUS) {
		window.__JIRA_READY_STATUS = Object.assign(window.__JIRA_READY_STATUS, status);
	}
};

const ReportApplicationReady = () => {
	useEffect(() => {
		setReadyStatus({
			readyForInteractions: true,
		});
	}, []);
	return null;
};

export const ReadinessTracker = (): React.JSX.Element | null => {
	useEffect(() => {
		if (typeof window !== 'undefined') {
			window.__JIRA_READY_STATUS = {
				started: true,
				loaded: false,
				onhold: true,
			};
			setReadyStatus({ readyForInteractions: false });
		}
	}, []);

	useEffect(() => {
		if (typeof window !== 'undefined') {
			const onPageReady = () => {
				window.__JIRA_READY_STATUS.onhold = false;
			};
			window.addEventListener('UFO_FINISH_INTERACTION', onPageReady);
			return () => {
				window.removeEventListener('UFO_FINISH_INTERACTION', onPageReady);
			};
		}
	}, []);

	const [{ hasLoaded }] = usePageLoadedSubscriber();

	useEffect(() => {
		if (hasLoaded) {
			if (typeof window !== 'undefined') {
				// we track "loaded" status as jira "loading end"
				window.__JIRA_READY_STATUS.loaded = true;
			}
		}
	}, [hasLoaded]);

	const ReadynessEvent = useIsHydrateRenderMode()
		? RenderAfterGlobalHydrationCompletion
		: BackgroundPriority;

	return (
		<ReadynessEvent>
			<ReportApplicationReady />
		</ReadynessEvent>
	);
};
